const baseUrl = import.meta.env.VITE_APP_API_URL;
const widgetUrl = import.meta.env.VITE_WIDGET_SNIPPET_URL;

const clickupScriptUrl =
  "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
const clickupFormUrl =
  "https://forms.clickup.com/9011807284/f/8cjah1m-2931/TXYC439WWALQLLSJSB";

export { baseUrl, widgetUrl, clickupScriptUrl, clickupFormUrl };
